import * as React from "react";
import type { SVGProps } from "react";
const SvgAbReleases = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 23" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M18.886 11.517v-4.55a3.734 3.734 0 0 0-3.734-3.734H9.784m1.634 17.269H5.35a3.734 3.734 0 0 1-3.734-3.734v-5.134"
    />
    <path
      fill="currentColor"
      d="M1.54 9.617H0L3.46 0h1.677l3.461 9.617h-1.54L4.34 1.747h-.075zm.26-3.766h4.996v1.221H1.8zm11.62 16.86v-9.416h3.448q1.002 0 1.66.33.657.327.983.888.327.557.327 1.255 0 .59-.216.994a1.8 1.8 0 0 1-.58.643q-.359.24-.79.35v.092q.468.023.914.303.451.276.745.786t.294 1.242q0 .72-.34 1.296-.335.57-1.039.906-.703.33-1.798.331zm1.42-1.218h2.05q1.02 0 1.463-.396.441-.395.441-.988 0-.446-.225-.819a1.6 1.6 0 0 0-.644-.593q-.414-.22-.984-.22H14.84zm0-4.125h1.903q.48 0 .86-.183.386-.185.612-.515.23-.336.23-.791 0-.585-.41-.98-.408-.395-1.255-.395h-1.94z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m13.74 7.274-4.041 5.253-4.042 5.254"
    />
  </svg>
);
export default SvgAbReleases;
